import MedicalSerializer from './base';

export default class Log extends MedicalSerializer {}
